import { request } from './request.js'

export const getActivities = () => request.get('activities')
export const getActivitiesById = id => request.get(`activities/${id}`)
export const getActivitiesFive = id => request.get(`activities_five/${id}`)
export const updateActivityFive = (id, data) => request.put(`activities_five/${id}/${data}`)
